module.exports = __webpack_public_path__ + "img/woman-logs@2x.22f7d5c9.png";